import React, { useEffect, useState } from "react";
import { generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels } from "./../../utils";
import { proxy } from '../../process/api';
import UserDT from "../UserDT";

import ProcessLoader from "../ProcessLoader";
const TL01 = () => {

    const [pageTitle, setPageTitle] = useState('');
    const [showProcessLoader, setShowProcessLoader] = useState(true);
    const [showResetProcess, setshowResetProcess] = useState(false);
    const [userList, setUserList] = useState({});


    const resetHandleFn = async(ID)=>{
     
        if(window.confirm("You sure you want to reset password for this user?")){
            setshowResetProcess(true);
            const apiResponse =  await proxy(`/auth/resetPassword/`+ID, {}, "post");
            setshowResetProcess(false);
            alert(apiResponse);
        }
       
    }
    const loadUserList = async() =>{
        const  userAPIResponse = await proxy(`/auth/userList`, {}, "get");
        
        setShowProcessLoader(false);
        setUserList(userAPIResponse);
    }
    const changeUserStatusFn = async(ID, status)=>{
     
        if(window.confirm("You sure you want to change status for this user?")){
            setshowResetProcess(true);
            const apiResponse =  await proxy(`/auth/changeUserStatus/`, {"user_id":ID, "user_status":status}, "post");
            setshowResetProcess(false);
            alert(apiResponse);
            
            const updatedUsers = userList.data.map(user =>
                user.login_id === ID ? { ...user, user_status: status } : user
              );
              setUserList({ ...userList, data: updatedUsers });
            
        }
       
    }

    useEffect(() => {
        loadUserList();
        transformNavDataForLabels("TL01").then(title => {
            setPageTitle(title);
        });

    }, []);

    return (
        <>
          {showResetProcess && <ProcessLoader /> }
            <div class="main-content">
            {showProcessLoader ? <ProcessLoader /> :
                   <>
                   <div className="row">
                       <div className="col-12">
                           <div className="card report-card" style={{ width: "min-content" }}>
                               <div className="card-title report-card-title">{userList.title}
                                   <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                               </div>
                               <div className="card-body">
                                   <UserDT
                                       tableData={userList}
                                   
                                       fixedColumns={true}
                                       resetHandle={resetHandleFn}
                                       changeUserStatus={changeUserStatusFn}
                                       
                                   />

                               </div>
                             
                           </div>
                       </div>
                   </div>
               </>}
            </div>
        </>
    );
}

export default TL01;